import type { ScanGroupOptimized, ScanTaskOptimized } from '@kaiizen/kai-scan-template-system';
import { useCallback, useState } from 'react';

import type { ProgressUpdateTarget } from './progressUpdateModalTypes';

export const useProgressUpdateModalState = () => {
  const [target, setTarget] = useState<ProgressUpdateTarget | null>(null);

  const close = useCallback(() => setTarget(null), []);

  const openForTask = useCallback(
    ({ groupId, group, task }: { groupId: string; group?: ScanGroupOptimized; task: ScanTaskOptimized }) => {
      setTarget({ groupId, group, task });
    },
    [],
  );

  return {
    target,
    open: target != null,
    openForTask,
    close,
  };
};
